/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BasicModel,
    BasicModelFromJSON,
    BasicModelFromJSONTyped,
    BasicModelToJSON,
} from './BasicModel';
import {
    DocumentModel,
    DocumentModelFromJSON,
    DocumentModelFromJSONTyped,
    DocumentModelToJSON,
} from './DocumentModel';
import {
    OfferFormRenterBidViewModel,
    OfferFormRenterBidViewModelFromJSON,
    OfferFormRenterBidViewModelFromJSONTyped,
    OfferFormRenterBidViewModelToJSON,
} from './OfferFormRenterBidViewModel';
import {
    RequestFormAdditionalServices,
    RequestFormAdditionalServicesFromJSON,
    RequestFormAdditionalServicesFromJSONTyped,
    RequestFormAdditionalServicesToJSON,
} from './RequestFormAdditionalServices';

/**
 * 
 * @export
 * @interface OfferFormRenterViewModel
 */
export interface OfferFormRenterViewModel {
    /**
     * 
     * @type {number}
     * @memberof OfferFormRenterViewModel
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof OfferFormRenterViewModel
     */
    creationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OfferFormRenterViewModel
     */
    expireDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof OfferFormRenterViewModel
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OfferFormRenterViewModel
     */
    company?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OfferFormRenterViewModel
     */
    lessorCompanyId?: number | null;
    /**
     * 
     * @type {Array<BasicModel>}
     * @memberof OfferFormRenterViewModel
     */
    machines?: Array<BasicModel> | null;
    /**
     * 
     * @type {Array<DocumentModel>}
     * @memberof OfferFormRenterViewModel
     */
    documents?: Array<DocumentModel> | null;
    /**
     * 
     * @type {Array<OfferFormRenterBidViewModel>}
     * @memberof OfferFormRenterViewModel
     */
    bids?: Array<OfferFormRenterBidViewModel> | null;
    /**
     * 
     * @type {Array<BasicModel>}
     * @memberof OfferFormRenterViewModel
     */
    paymentTypes?: Array<BasicModel> | null;
    /**
     * 
     * @type {Array<BasicModel>}
     * @memberof OfferFormRenterViewModel
     */
    billingTimeOptions?: Array<BasicModel> | null;
    /**
     * 
     * @type {string}
     * @memberof OfferFormRenterViewModel
     */
    notes?: string | null;
    /**
     * 
     * @type {RequestFormAdditionalServices}
     * @memberof OfferFormRenterViewModel
     */
    additionalServices?: RequestFormAdditionalServices;
}

export function OfferFormRenterViewModelFromJSON(json: any): OfferFormRenterViewModel {
    return OfferFormRenterViewModelFromJSONTyped(json, false);
}

export function OfferFormRenterViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferFormRenterViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'creationDate': !exists(json, 'creationDate') ? undefined : (new Date(json['creationDate'])),
        'expireDate': !exists(json, 'expireDate') ? undefined : (new Date(json['expireDate'])),
        'status': !exists(json, 'status') ? undefined : json['status'],
        'company': !exists(json, 'company') ? undefined : json['company'],
        'lessorCompanyId': !exists(json, 'lessorCompanyId') ? undefined : json['lessorCompanyId'],
        'machines': !exists(json, 'machines') ? undefined : (json['machines'] === null ? null : (json['machines'] as Array<any>).map(BasicModelFromJSON)),
        'documents': !exists(json, 'documents') ? undefined : (json['documents'] === null ? null : (json['documents'] as Array<any>).map(DocumentModelFromJSON)),
        'bids': !exists(json, 'bids') ? undefined : (json['bids'] === null ? null : (json['bids'] as Array<any>).map(OfferFormRenterBidViewModelFromJSON)),
        'paymentTypes': !exists(json, 'paymentTypes') ? undefined : (json['paymentTypes'] === null ? null : (json['paymentTypes'] as Array<any>).map(BasicModelFromJSON)),
        'billingTimeOptions': !exists(json, 'billingTimeOptions') ? undefined : (json['billingTimeOptions'] === null ? null : (json['billingTimeOptions'] as Array<any>).map(BasicModelFromJSON)),
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'additionalServices': !exists(json, 'additionalServices') ? undefined : RequestFormAdditionalServicesFromJSON(json['additionalServices']),
    };
}

export function OfferFormRenterViewModelToJSON(value?: OfferFormRenterViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'creationDate': value.creationDate === undefined ? undefined : (value.creationDate.toISOString()),
        'expireDate': value.expireDate === undefined ? undefined : (value.expireDate.toISOString()),
        'status': value.status,
        'company': value.company,
        'lessorCompanyId': value.lessorCompanyId,
        'machines': value.machines === undefined ? undefined : (value.machines === null ? null : (value.machines as Array<any>).map(BasicModelToJSON)),
        'documents': value.documents === undefined ? undefined : (value.documents === null ? null : (value.documents as Array<any>).map(DocumentModelToJSON)),
        'bids': value.bids === undefined ? undefined : (value.bids === null ? null : (value.bids as Array<any>).map(OfferFormRenterBidViewModelToJSON)),
        'paymentTypes': value.paymentTypes === undefined ? undefined : (value.paymentTypes === null ? null : (value.paymentTypes as Array<any>).map(BasicModelToJSON)),
        'billingTimeOptions': value.billingTimeOptions === undefined ? undefined : (value.billingTimeOptions === null ? null : (value.billingTimeOptions as Array<any>).map(BasicModelToJSON)),
        'notes': value.notes,
        'additionalServices': RequestFormAdditionalServicesToJSON(value.additionalServices),
    };
}

